import axios from 'axios';
import API from '../config/api.config';

export default class ParkingEvents {
  constructor() {
    this.API = API;
  }

  apiEndpoint() {
    return this.API.URL('parking_events');
  }

  getEvents(params) {
    return axios.get(this.apiEndpoint(), {params: params});
  }
}
